<template>
  <div class="coach-dig-container mx-auto p-4 bg-white shadow-md rounded-md max-w-4xl relative">
      <div class="flex items-center justify-between mb-6">
           <router-link to="/" class="no-underline text-blue-600">
             <h1 class="font-oswald text-3xl text-blue-600 tracking-wide text-shadow-md">interbot.me</h1>
            </router-link>
         <h2 class="font-oswald text-2xl text-gray-700">Mentores 1-1</h2>
        <div class="flex items-center gap-2">
           <input v-model="searchQuery" type="text" placeholder="Buscar..." class="filter-search border rounded p-2 w-full max-w-xs focus:outline-none focus:ring-2 focus:ring-blue-300"/>
        </div>
       </div>
   <div v-for="coach in filteredCoaches" :key="coach.id">
          <MentorCard :coach="coach" @book="bookCoach"/>
   </div>
  </div>
</template>

<script>
import MentorCard from '../components/MentorCard.vue';
import image4 from '../assets/image-4.jpg';

export default {
name: 'coachDig',
  components: {
      MentorCard
  },
data() {
  return {
    searchQuery: '',
      coaches: [
            {
                id: 1,
                image: image4,
              name: 'Elena Rodriguez',
                title: 'CEO de Innovación Tech',
                bio: 'Líder en estrategias de transformación digital y expansión de mercados.',
                labels: ['Transformación Digital', 'Liderazgo', 'Crecimiento', 'Tech'],
              price: '$250/sesión',
                available: true,
                showAllLabels: false,
        },
        {
           id: 2,
             image: image4,
            name: 'Carlos Martínez',
                title: 'Experto en Marketing Digital',
                bio: 'Especialista en SEO, redes sociales y marketing de contenidos para startups.',
               labels: ['SEO', 'Redes Sociales', 'Marketing de Contenidos', 'email', 'Marketing'],
              price: '$180/sesión',
                available: true,
                showAllLabels: false,
          },
            {
                id: 3,
                image: image4,
              name: 'Sofía Gómez',
                title: 'Coach de Desarrollo Profesional',
                bio: 'Ayuda a profesionales a alcanzar sus metas de carrera y superar obstáculos.',
               labels: ['Desarrollo Profesional', 'Habilidades Blandas', 'Liderazgo', 'Coach'],
                price: '$200/sesión',
               available: false,
                showAllLabels: false,
        },
            {
                id: 4,
                image: image4,
             name: 'Alejandro Vargas',
                title: 'Consultor de Estrategia Empresarial',
               bio: 'Experiencia en planeación estratégica, análisis de mercado y gestión de proyectos.',
              labels: ['Estrategia Empresarial', 'Análisis de Mercado', 'Gestión de Proyectos', 'Finanzas'],
               price: '$300/sesión',
                available: true,
               showAllLabels: false,
         },
          {
               id: 5,
                image: image4,
            name: 'Isabela Torres',
               title: 'Especialista en Recursos Humanos',
               bio: 'Focalizada en reclutamiento, retención de talento y cultura organizacional.',
                labels: ['Recursos Humanos', 'Reclutamiento', 'Cultura Organizacional', 'HR'],
              price: '$150/sesión',
               available: false,
               showAllLabels: false,
           },
          {
             id: 6,
              image: image4,
            name: 'Ricardo Pérez',
              title: 'Asesor de Finanzas Personales',
              bio: 'Guía a individuos en la toma de decisiones financieras y estrategias de inversión.',
               labels: ['Finanzas Personales', 'Inversiones', 'Planificación Financiera', 'Finanzas'],
               price: '$120/sesión',
               available: true,
                showAllLabels: false,
         },
           {
                id: 7,
                image: image4,
             name: 'Laura Ramírez',
                title: 'Mentora de Emprendimiento',
               bio: 'Apoya a emprendedores a desarrollar sus ideas y crecer sus negocios.',
              labels: ['Emprendimiento', 'Startups', 'Desarrollo de Negocios', 'Finanzas', 'Coach'],
              price: '$220/sesión',
                 available: true,
                showAllLabels: false,
          },
            {
              id: 8,
               image: image4,
            name: 'Gabriel Castro',
                title: 'Especialista en Analítica de Datos',
                bio: 'Experto en análisis de datos, visualización y toma de decisiones basadas en datos.',
              labels: ['Análisis de Datos', 'Visualización', 'Big Data', 'IA'],
              price: '$280/sesión',
                 available: true,
                 showAllLabels: false,
          },
            {
             id: 9,
                image: image4,
           name: 'Valeria Ruiz',
               title: 'Consultora de Comunicación',
                bio: 'Ayuda a profesionales a mejorar su comunicación, oratoria y relaciones públicas.',
                labels: ['Comunicación', 'Oratoria', 'Relaciones Públicas', 'Personal'],
              price: '$190/sesión',
                available: false,
                showAllLabels: false,
          },
          {
             id: 10,
              image: image4,
           name: 'Daniel Vargas',
                title: 'Asesor de Transformación Personal',
              bio: 'Acompaña a personas en su desarrollo personal, bienestar y autoconocimiento.',
                labels: ['Desarrollo Personal', 'Bienestar', 'Autoconocimiento', 'Personal'],
             price: '$170/sesión',
               available: true,
                showAllLabels: false,
          }
      ]
    };
  },
  computed: {
     filteredCoaches() {
      let filtered = this.coaches;
      if (this.searchQuery) {
        const searchTerm = this.searchQuery.toLowerCase();
        filtered = filtered.filter(coach => {
          return (
            coach.name.toLowerCase().includes(searchTerm) ||
            coach.title.toLowerCase().includes(searchTerm) ||
              coach.bio.toLowerCase().includes(searchTerm) ||
            coach.labels.some(label => label.toLowerCase().includes(searchTerm))
          );
        });
      }
      return filtered;
    }
  },
  methods: {
     bookCoach(coach) {
         console.log("Agendando al coach:", coach);
        }
  },
};
</script>